import { useEffect } from "react";
import Lenis from "lenis";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Philosophy from "./components/Philosophy";
import Portfolio from "./components/Portfolio";
import Collaborations from "./components/Collaborations";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return children;
};

function App() {
  return (
    <LanguageProvider>
      <SmoothScroll>
        <div className="min-h-screen bg-travertine-light text-ink antialiased">
          <div className="grain-overlay" />
          <Navbar />
          <main>
            <Hero />
            <Marquee />
            <Philosophy />
            <Portfolio />
            <Collaborations />
            <Services />
            <Contact />
          </main>
          <Footer />
        </div>
      </SmoothScroll>
    </LanguageProvider>
  );
}

export default App;
